var modules_6b210db9 = {"container":"_imtian","item-base":"_w0xa45","item-group":"_1sxctjw","item":"_1ooh2nu","active":"_1equotx","disabled":"_2nrj19","icon":"_1jl3o5i","control":"_1nj0g1t","control-indent":"_waw2do","description":"_nbav3b","text":"_19fz4c4","label":"_14npnk2"};
import "../../../assets/Bj7VAY-b.css";

export { modules_6b210db9 as default };
//# sourceMappingURL=Menu.module.less.js.map
